/**
 * Article source platforms
 */
export enum ArticleSource {
  WORDPRESS = 'WordPress',
  RSS_FEED = 'RSS Feed',
  CUSTOM = 'Custom',
}

/**
 * Article data from webhook response
 * Matches REFINED-SCHEMAS.md specification
 */
export interface ArticleData {
  // Core identification
  id: string;

  // Display fields
  title: string;
  author: string;
  publishDate: Date;
  excerpt: string;

  // Source information
  sourcePlatform: ArticleSource | string;
  articleUrl: string;

  // Content
  content: string;

  // Metadata for filtering (optional)
  category?: string;
  tags?: string[];
  imageUrl?: string;

  // Status tracking
  hasBeenUsed?: boolean;
  usedInEpisodeId?: string;
}

/**
 * Request payload for article search webhook
 */
export interface ArticleSearchRequest {
  companyId: string;
  searchTerm?: string;
  category?: string;
  limit?: number;
  offset?: number;
}

/**
 * Response from article search webhook
 */
export interface ArticleSearchResponse {
  success: boolean;
  articles: ArticleData[];
  total: number;
  hasMore: boolean;
  error?: string;
}

/**
 * Query options for filtering articles in UI
 */
export interface ArticleFilterOptions {
  searchTerm?: string;
  category?: string;
  sourcePlatform?: ArticleSource;
  showUsed?: boolean;  // Show articles already converted to episodes
}
